<template>
  <div>
    <div v-if="group.all_units && group.all_units.length > 1" class="alert alert-danger d-print-none">
      <p class="m-0" v-html="`Os itens abaixo estão com unidades descritas de forma diferente: <b><br>• ${group.all_units.join('<br>• ')}.</b>`"></p>
    </div>

    <div class="card mb-4">
      <div class="card-header">
        <strong>{{ group.name }}</strong>
      </div>
      <div class="card-body">
        <div v-for="(item, index) in group.report_group_items" :key="item.id" :class="`fade-in-subtle fade-in-stagger-${Math.min(index + 1, 5)}`">
          <ReportItemDetails :item="item" @item-removed="handleItemRemoved" />
          <hr v-if="index < group.report_group_items.length - 1" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportItemDetails from './ReportItemDetails.vue'

export default {
  name: 'ReportGroup',
  components: {
    ReportItemDetails
  },
  props: {
    group: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleItemRemoved(itemId) {
      this.$emit('item-removed', itemId)
    }
  }
}
</script>